<template>
    <Menu as="div" class="relative">
        <MenuButton class="-m-1.5 flex items-center p-1.5">
            <span class="sr-only">Open user menu</span>
            <img
                class="h-8 w-8 rounded-full bg-gray-50"
                :src="$page.props.user.profile_photo_url"
                alt="User Profile"
            />
            <span class="hidden lg:flex lg:items-center">
                <span class="ml-4 text-sm font-semibold leading-6 text-white" aria-hidden="true">{{ $page.props.user.fullname }} ( <strong>{{ $page.props.session_role.role_display_name }} )</strong></span>
                <ChevronDownIcon class="ml-2 h-5 w-5 text-gray-400" aria-hidden="true" />
            </span>
        </MenuButton>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems class="absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-white/5 focus:outline-none">
                <MenuItem v-for="item in profileMenu" :key="item.name" v-slot="{ active }">
                    <template v-if="item.href === 'logout'">
                        <form @submit.prevent="logout">
                            <a
                                href="#"
                                :class="[active ? 'bg-gray-50' : '', 'block w-full px-3 py-1 text-left text-sm leading-6 text-gray-900']"
                                @click.prevent="logout"
                            >
                                {{ item.name }}
                            </a>
                        </form>
                    </template>
                    <template v-else>
                        <a
                            :href="route(item.href)"
                            :class="[active ? 'bg-gray-50' : '', 'block px-3 py-1 text-sm leading-6 text-gray-900']"
                        >
                            {{ item.name }}
                        </a>
                    </template>


                </MenuItem>
<!--                // menu session role yang aktif-->

                <MenuItem v-slot="{ active }">
                    <a
                        :href="route('roles.switch')"
                        :class="[active ? 'bg-gray-50' : '', 'block w-full px-3 py-1 text-left text-sm leading-6 text-gray-900 font-medium']"
                    >
                        Change Role
                    </a>
                </MenuItem>

            </MenuItems>
        </transition>
    </Menu>
</template>

<script>
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import axios from 'axios';

export default {
    name: 'ProfileDropdown',
    components: {
        Menu,
        MenuButton,
        MenuItems,
        MenuItem,
        ChevronDownIcon
    },
    props: {
        user: {
            type: Object,
            required: true
        },
        profileMenu: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            dropdownOpen: false
        };
    },
    methods: {
        async logout() {
            try {
                await axios.post('/logout');
                window.location.href = '/';
            } catch (error) {
                console.error('Logout failed:', error);
            }
        }
    }
};
</script>
